import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import PropTypes from 'prop-types';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const InfoDialog = ({ header, content, open, setOpen }) => {
  const handleClose = () => setOpen(false);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slots={{
        transition: Transition,
      }}
      maxWidth="sm"
      fullWidth
      slotProps={{ paper: { sx: { borderRadius: 3, boxShadow: '0 8px 32px rgba(0,0,0,0.12)' } } }}
      sx={{
        background: `linear-gradient(135deg, #1976d2 0%, #ffffff 100%)`,
      }}
    >
      <DialogTitle>{header}</DialogTitle>
      <DialogContent>
        {content}
        <div
          style={{
            marginTop: 20,
            textAlign: 'center',
            fontSize: 12,
            color: '#555',
            opacity: 0.7,
          }}
        >
          Click anywhere outside this box to return to the dashboard
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InfoDialog;

InfoDialog.propTypes = {
  header: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};
